export default "__VITE_ASSET__C9Hc4CfN__"